export const siteText = {
  firstWord: 'COSMETOLOGY ',
  lastWord: 'COSMETOLOGY ',
};
